import { useEffect } from "react"

import { Form } from "@/components/forms/Form"
import { RadioField } from "@/components/forms/RadioField"
import { StringListField } from "@/components/forms/StringListField"
import { TextField } from "@/components/forms/TextField"
import { Textarea } from "@/components/forms/Textarea"
import type { LicenseData } from "@/hooks/useLicenseStore"
import { useStrings } from "@/hooks/useStrings"
import type { UseFormReturn } from "react-hook-form"
import { YearField } from "../../forms/YearField"

type DatasetDetailsProps = {
  form: UseFormReturn<LicenseData>
}

export const DatasetDetails = ({ form }: DatasetDetailsProps) => {
  const strings = useStrings()
  const includeDetailsSelection = form.watch("includeDatasetDetails")
  const options = [strings.option.no, strings.option.yes].filter(Boolean) as string[]
  const includeDetails = includeDetailsSelection === strings.option.yes
  const identifiersList = form.getValues("identifiersList") as string[] | undefined
  const hasExistingDetails = Boolean(
    form.getValues("datasetTitle") ||
      form.getValues("datasetDescription") ||
      form.getValues("yearGenerated") ||
      (identifiersList?.length ?? 0)
  )

  useEffect(() => {
    if (includeDetailsSelection != null && !includeDetails) {
      form.resetField("datasetTitle", { defaultValue: "" })
      form.resetField("datasetDescription", { defaultValue: "" })
      form.resetField("yearGenerated", { defaultValue: "" })
      form.resetField("identifiersList", { defaultValue: [] })
    }
  }, [form, includeDetails, includeDetailsSelection])

  return (
    <Form form={form}>
      <RadioField
        form={form}
        name="includeDatasetDetails"
        label={strings.title.datasetDetailsPrompt}
        description={strings.question.datasetDetailsPrompt}
        options={options}
        layout="inline"
        defaultValue={hasExistingDetails ? strings.option.yes : strings.option.no}
      />
      {includeDetails ? (
        <>
          <TextField
            form={form}
            name="datasetTitle"
            label={strings.title.datasetTitle}
            description={strings.question.datasetTitle}
          />
          {/* <Textarea */}
          <TextField
            form={form}
            name="datasetDescription"
            label={strings.title.datasetDescription}
            // description={strings.question.datasetDescription}
            textareaProps={{ rows: 6 }}
          />
          {/* <TextField */}
          <YearField
            form={form}
            name="yearGenerated"
            label={strings.title.yearGenerated}
            description={strings.question.yearGenerated}
            // inputProps={{ inputMode: "numeric", maxLength: 4, pattern: "^\\d{0,4}$" }}
            inputProps={{ inputMode: "numeric" }}
          />
          <StringListField
            form={form}
            name="identifiersList"
            label={strings.title.identifiersList}
            description={strings.question.identifiersList}
            addButtonLabel={strings.action.addIdentifier}
            removeButtonLabel={strings.action.removeIdentifier}
          />
        </>
      ) : null}
    </Form>
  )
}
